import { parseTheme } from "@sqymagma/theme";
import React from "react";
import { ThemeProvider } from "styled-components";
import _defaultTheme from "../themes/theme.json";
import Helmet from "react-helmet";
import Footer from "../components/Footer";
import Navigation from "../components/SiteNavigation/Index";
import Transition from "../components/Transition";
const defaultTheme = parseTheme(_defaultTheme);

const RegularLayout = ({ children, path, location }) => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>COVID-19-ES</title>
          <link rel="canonical" href="https://coronavirus.secuoyas.com" />
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta property="og:title" content="covid·19-es" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="covid·19-es" />
          <meta property="og:url" content="coronavirus.secuoyas.com" />
          <meta property="og:image" content="img/open-graph-image-black.png" />
          <meta property="og:image:alt" content="covid·19-es logo" />
          <meta
            name="description"
            content="Recursos sobre el coronavirus covid-19 SARS-Cov-2"
          />
          <link itemprop="image" href="img/open-graph-image-black.png" />
        </Helmet>
        <Navigation path={path} />

        <Transition location={location}>{children}</Transition>

        <Footer />
      </React.Fragment>
    </ThemeProvider>
  );
};

export default RegularLayout;
